export default __webpack_public_path__ + "static/media/Snd_TryM.1a774c35.mp3";